import { jwtDecode } from "jwt-decode";

export const parseGroupsFromToken = (token) => {
    if (!token) {
        console.warn("No token provided for group parsing.");
        return [];
    }

    try {
        const decoded = jwtDecode(token);
        const groups = decoded.groups || decoded["cognito:groups"] || [];
        return groups;
    } catch (error) {
        console.error("Error decoding token for groups:", error);
        return [];
    }
};

export const hasGroup = (token, requiredGroup) => {
    const groups = parseGroupsFromToken(token);
    const hasGroup = groups.includes(requiredGroup);
    return hasGroup;
};

export const findAccessToken = () => {
    for (const key in localStorage) {
        if (key.includes(".accessToken")) {
            const token = localStorage.getItem(key);
            return token;
        }
    }

    console.warn("No access token found in localStorage.");
    return null;
};
